import { PackagePickerSteps } from '@wix/package-picker-shared';
export let EclipsePackagePickerSteps = function (EclipsePackagePickerSteps) {
  EclipsePackagePickerSteps[EclipsePackagePickerSteps["SELECT_PLAN"] = PackagePickerSteps.SELECT_PLAN] = "SELECT_PLAN";
  EclipsePackagePickerSteps[EclipsePackagePickerSteps["SELECT_CYCLE"] = PackagePickerSteps.SELECT_CYCLE] = "SELECT_CYCLE";
  EclipsePackagePickerSteps[EclipsePackagePickerSteps["CHECKOUT"] = PackagePickerSteps.CHECKOUT] = "CHECKOUT";
  EclipsePackagePickerSteps[EclipsePackagePickerSteps["ANY"] = PackagePickerSteps.ANY] = "ANY";
  return EclipsePackagePickerSteps;
}({});
export let FeatureNamespace = /*#__PURE__*/function (FeatureNamespace) {
  FeatureNamespace["STICKY"] = "sticky";
  FeatureNamespace["MAIN"] = "main";
  FeatureNamespace["SECONDARY"] = "secondary";
  return FeatureNamespace;
}({});
//# sourceMappingURL=types.js.map